module.exports = __webpack_public_path__ + "img/restriction-limited.6f7fe691.png";